import { Injectable } from '@angular/core';
import { DeviceConnectivityModule } from '@iot-platform/models/common';
import { Device } from '@iot-platform/models/i4b';
import { Observable } from 'rxjs';
import { AbstractDeviceConnectivityModuleService } from './abstract-device-connectivity-module.service';

@Injectable({
  providedIn: 'root'
})
export class DeviceConnectivityModuleService extends AbstractDeviceConnectivityModuleService<Device> {
  getConnectivityDetails(device: Device): Observable<DeviceConnectivityModule> {
    return this.httpClient.get<DeviceConnectivityModule>(
      `${this.environment.api.url_connector}${this.environment.api.endpoints.deviceDetails}/${device.identifier}/connectivity-module`
    );
  }
}
